// extracted by mini-css-extract-plugin
export default {"mapBoard":"LevelBackgroundTilesLayer_mapBoard__6Nz1R"};